import React, { Fragment } from 'react'
import { Button } from '@atd/rui-base.mui.button'
import ResponsiveDialog from '../commonComponents/responsiveDialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import DialogHeader from '../commonComponents/dialogHeader'
import ValidatedTextField from '../commonComponents/validatedTextField'
import PropTypes from 'prop-types'

import {alphanumCount} from '../lib/stringValidation'
import { emptyForNull } from '../lib/formData'

class FarmEdit extends React.Component {
    static propTypes = {
        data: PropTypes.object,
    }

    static defaultProps = {
        data: {
            id: -1,
            growerId: -1,
            name: '',
            address: '',
            address2: '',
            city: '',
            county: '',
            region: '',
            country: '',
            postalCode: '',
            phoneNumber: '',
            mobileNumber: '',
            faxNumber: '',
            email: '',
            firstName: '',
            middleName: '',
            lastName: '',
            comments: '',
        },
        disabled: false,
    }

    state = {
        open: true,
        ...emptyForNull(this.props.data),
        errorMessage: '',
    }

    handleChange = (event) => {
        const formData = {...this.state}
        formData[event.target.name] = event.target.value
        this.setState(formData)
    }

    // eslint-disable-next-line
    handleSubmit = () => {
        if (!this.state.name || this.state.name.length > 32 ||
            (this.state.firstName && this.state.firstName.length > 32) ||
            (this.state.middleName && this.state.middleName.length > 32) ||
            (this.state.lastName && this.state.lastName.length > 32) ||
            (this.state.phoneNumber && this.state.phoneNumber.length > 20) ||
            (this.state.mobileNumber && this.state.mobileNumber.length > 20) ||
            (this.state.faxNumber && this.state.faxNumber.length > 20) ||
            (this.state.email && this.state.email.length > 64) ||
            (this.state.address && this.state.address.length > 32) ||
            (this.state.address2 && this.state.address2.length > 32) ||
            (this.state.city && this.state.city.length > 32) ||
            (this.state.county && this.state.county.length > 32) ||
            (this.state.region && this.state.region.length > 32) ||
            alphanumCount(this.state.postalCode) > 10 ||
            (this.state.country && this.state.country.length > 32) ||
            (this.state.comments && this.state.comments.length > 330)
        ) {
            this.setState({errorMessage: 'Invalid Data'})
        }
        else {
            this.requestClose(() => this.props.onSubmit({ ...this.state }))
        }
    }
    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    handleCancel = () => {
        this.requestClose(this.props.onCancel)
        this.setState({
            ...emptyForNull(this.props.data),
            errorMessage: '',
        })
    }

    renderActions = () => {
        if (this.props.disabled) {
            return [
                <Button key="close" variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}
                    name="closeButton">{'Close'}</Button>,
            ]
        }

        return [
            <div key="error" style={{display: 'inline-block', color: 'red'}}>{this.state.errorMessage}</div>,
            <Button key="cancel" variant="text"
                color="primary"
                onClick={this.handleCancel}
                name="cancelButton">Cancel</Button>,
            <Button key="save" variant="contained"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_SaveWhite.svg`}/>}
                color="primary"
                onClick={this.handleSubmit}
                name="saveButton">{'Save'}</Button>,
        ]
    }

    renderContactFields = () => {
        return <Fragment>
            <h3>Contact Information</h3>
            <ValidatedTextField
                disabled={this.props.disabled}
                label="First Name"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.firstName}
                name="firstName"
                errorText={this.state.firstName && this.state.firstName.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Middle Name"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.middleName}
                name="middleName"
                errorText={this.state.middleName && this.state.middleName.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Last Name"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.lastName}
                name="lastName"
                errorText={this.state.lastName && this.state.lastName.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Phone Number"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.phoneNumber}
                name="phoneNumber"
                errorText={this.state.phoneNumber && this.state.phoneNumber.length > 20 && 'Max Length 20'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Mobile Number"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.mobileNumber}
                name="mobileNumber"
                errorText={this.state.mobileNumber && this.state.mobileNumber.length > 20 && 'Max Length 20'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Fax Number"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.faxNumber}
                name="faxNumber"
                errorText={this.state.faxNumber && this.state.faxNumber.length > 20 && 'Max Length 20'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Email"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.email}
                name="email"
                errorText={this.state.email && this.state.email.length > 64 && 'Max Length 64'}
            />
        </Fragment>
    }

    renderAddressFields = () => {
        return <Fragment>
            <h3>Address</h3>
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Address 1"
                InputLabelProps={{ shrink: true }}
                placeholder="Ex: 1234 Apple Lane"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.address}
                name="address"
                errorText={this.state.address && this.state.address.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Address 2"
                InputLabelProps={{ shrink: true }}
                placeholder="Ex: Suite 72"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.address2}
                name="address2"
                errorText={this.state.address2 && this.state.address2.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="City"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.city}
                name="city"
                errorText={this.state.city && this.state.city.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="County"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.county}
                name="county"
                errorText={this.state.county && this.state.county.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="State"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.region}
                name="region"
                errorText={this.state.region && this.state.region.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Zip Code"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.postalCode}
                name="postalCode"
                errorText={alphanumCount(this.state.postalCode) > 10 && 'Max 10 alphanum characters'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Country"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.country}
                name="country"
                errorText={this.state.country && this.state.country.length > 32 && 'Max Length 32'}
            />
        </Fragment>
    }

    render() {
        const editActions = this.renderActions()

        return (
            <ResponsiveDialog
                open={this.state.open}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.handleSubmit() }}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                PaperProps={{className: 'wodialog'}}
                fullWidth
            >
                <DialogHeader onClose={this.handleCancel}>Farm Information</DialogHeader>
                <DialogContent>
                    <ValidatedTextField
                        disabled={this.props.disabled}
                        label="Farm Name"
                        fullWidth={true}
                        onChange={this.handleChange}
                        value={this.state.name}
                        name="name"
                        errorText={(!this.state.name && 'Required Field') || (this.state.name.length > 32 && 'Max Length 32')}
                    />
                    <br />
                    {this.renderContactFields()}
                    <br />
                    {this.renderAddressFields()}
                    <h3>Comments</h3>
                    <ValidatedTextField
                        disabled={this.props.disabled}
                        fullWidth={true}
                        onChange={this.handleChange}
                        value={this.state.comments}
                        multiline={true}
                        name="comments"
                        errorText={this.state.comments && this.state.comments.length > 330 && 'Max Length 330'}
                    />
                </DialogContent>
                <DialogActions>{editActions}</DialogActions>
            </ResponsiveDialog>
        )
    }
}

// be sure to connect the component to the Redux state so it can use it!
export default FarmEdit
